"use client"

import { useEffect } from "react"
import Link from 'next/link'
import { Logo } from '@/components/Logo'
import { usePrefetch } from '@/hooks/usePrefetch'
import { HugeiconsIcon } from '@hugeicons/react'
import { Cancel01Icon } from '@hugeicons-pro/core-stroke-rounded'

export default function AuthLayout({
  children,
}: {
  children: React.ReactNode
}) {
  const { prefetch } = usePrefetch()

  // Light prefetch: fewer routes + delay so first paint stays responsive
  useEffect(() => {
    const prefetchTimer = window.setTimeout(() => {
      prefetch('/login', { delay: 0 })
      prefetch('/signup', { delay: 80 })
      prefetch('/magic-link', { delay: 160 })
    }, 320)
    return () => window.clearTimeout(prefetchTimer)
  }, [prefetch])

  return (
    <div className="min-h-dvh w-full overflow-hidden">
      <div className="fixed left-0 top-0 z-0 h-full w-full" />
      <Link
        href="/"
        className="fixed top-4 right-4 z-20 flex h-10 w-10 items-center justify-center rounded-full bg-atrium-content/80 text-atrium-black/60 hover:text-atrium-black hover:bg-atrium-content transition-colors"
        aria-label="Close"
      >
        <HugeiconsIcon icon={Cancel01Icon} className="size-5" />
      </Link>

      <div className="flex h-full min-h-dvh w-full items-center justify-center">
        <div className="relative z-10 flex h-full min-h-0 w-full flex-col items-center justify-start lg:max-w-2xl">
          <div className="flex h-full min-h-0 w-full flex-col items-center justify-start overflow-y-auto px-4 pb-16 pt-2 sm:pb-20">
            <div className="sticky top-0 z-10 mb-6 mt-12 flex h-14 w-full shrink-0 items-center justify-center px-4 sm:mb-8 sm:mt-16">
              <Link href="/" prefetch={true}>
                <Logo />
              </Link>
            </div>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}
